import { PropsWithChildren, useLayoutEffect, useState } from "react";
import { ThemeOverrideWrapper } from "./themes";
import axios from "axios";
import { ThemeContext } from "./ThemeContext";


interface Props {}

export const ProLogsThemeProvider = ({
  children,
}: PropsWithChildren<Props>) => {
  const [brandTheme, setBrandTheme] = useState<ThemeOverrideWrapper>({});
  useLayoutEffect(() => {
    const controller = new AbortController();
    axios
      .get<ThemeOverrideWrapper>(
        process.env["REACT_APP_API_URL"]?.replace(/\/+$/, "") +
          "/branding/theme.json",
        {
          signal: controller.signal,
        }
      )
      .then((result) => {
        setBrandTheme(result.data);
      })
      .catch((e) => {
        console.info("Brand theme not found, using the default.");
      });

    return () => controller.abort();
  }, []);

  return (
    <ThemeContext.Provider value={brandTheme}>{children}</ThemeContext.Provider>
  );
};
